<template>
    <div>
        <v-card :loading="div_tt_load" class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                     Time Table
                </v-toolbar-title>
                <v-divider class="mx-4" color="white" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn rounded color="success" small @click="fnExcelReport('my-table-id', 'DivTT')"
                        :loading="loader"><v-icon color="white" small class="mr-1">mdi-export</v-icon>Export</v-btn>
                <v-checkbox v-if="user_type == 'Employee'" v-model="showRoom" color="white" text-color="white"
                    class="checkbox-label"></v-checkbox><span v-if="user_type == 'Employee'">Show Room</span>
                <v-checkbox v-if="user_type == 'Employee'" v-model="showFaculty" color="white" text-color="white"
                    class="checkbox-label"></v-checkbox><span v-if="user_type == 'Employee'">Show Faculty</span>
            </v-toolbar>

            <template v-if="div_tt_list != null">
                <div id="my-table-id">
                    <v-simple-table dense class="mytable elevation-1">
                        <caption>
                            <b>{{ std_name }} : {{ div_name }}</b>
                        </caption>
                        <thead>
                            <tr>
                                <th>AY : {{ dis_ay.ay }}</th>
                                <th class="toolbar" v-for="s in slots" :key="s.id">
                                    {{ s.start_time }} - {{ s.end_time }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="tt in div_tt_list" :key="tt.id">
                                <th class="toolbar" width="10%">
                                    <center>{{ tt[0].tt_day }}</center>
                                </th>
                                <td v-for="data in tt" :key="data.id">
                                    <!-- 1111ut {{user_type}} -->
                                    <!-- :title="`Subject:${data.tt_course_tip} Faculty:${data.tt_faculty_tip} Room:${data.tt_room} Event:${data.tt_event_tip}`" -->
                                    <v-btn small width="100%" :color="data.tt_slot_color" class="btn-grad"
                                        :title="user_type != 'Employee' ? `Subject:${data.tt_course_tip} Room:${data.tt_room} Event:${data.tt_event_tip}` : `${data.tt_course_tip} Faculty:${data.tt_faculty_tip} Room:${data.tt_room} Event:${data.tt_event_tip}`">
                                        <span v-if="data.tt_course != null || data.tt_event != null">
                                            <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                            {{ data.tt_course }}
                                        </span>
                                        <span v-if="showRoom && data.tt_room != null">
                                            <v-icon color="blue" small>mdi-warehouse</v-icon>
                                            {{ data.tt_room }}
                                        </span>
                                        <span v-if="data.tt_event_name != null">
                                            <v-icon color="green" small>mdi-cricket</v-icon>
                                            {{ data.tt_event_name }}
                                        </span>
                                        <span v-if="showFaculty && data.tt_faculty != '--' && user_type == 'Employee'">
                                            <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                                            {{ data.tt_faculty }}
                                        </span>
                                        <span v-if="showFaculty && data.tt_mul_inst != '' && user_type == 'Employee'">
                                            <v-icon color="#9808EB" small>mdi-account-plus</v-icon>
                                            <span v-for="i, index in data.tt_mul_inst" :key="index"> {{ index + 1 }}.{{ i
                                                }}</span>
                                        </span>
                                        <span v-if="data.tt_course != null || data.tt_event != null">
                                            <a :href="data.tt_web_link" class="btn-view"
                                                v-if="data.tt_web_link != null && data.tt_web_link != '--'"
                                                target="_blank">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn class="btn-view" x-small rounded depressed @click="
                                                            markattendance(
                                                                dis_ay,
                                                                div_id,
                                                                curr_lid,
                                                                data.tt_id
                                                            )
                                                            ">
                                                            <v-icon color="blue" class="btn-view" v-bind="attrs"
                                                                v-on="on" size="25">mdi mdi-link</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span> Webinar Link!!! </span>
                                                </v-tooltip>
                                            </a>
                                        </span>
                                    </v-btn>
                                    <span v-if="data.electives.length != 0">
                                        <v-tooltip right color="#00DBDE" dark>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on" width="100%" :id="data.tt_id"
                                                    v-for="(ele, index) in data.electives" :key="index" small
                                                    class="pt-1 pb-1 mt-2 btn1-grad"
                                                    :title="user_type != 'Employee' ? `Subject:${ele.ele_crs} Room:${ele.ele_room} Event:${ele.ele_event}` : `Subject:${ele.ele_crs} Room:${ele.ele_room} Event:${ele.ele_event} Instructor:${ele.ele_instructor}`">
                                                    <!-- :title="`Subject:${ele.ele_crs} Room:${ele.ele_room} Event:${ele.ele_event} Instructor:${ele.ele_instructor}`" -->
                                                    <span v-if="ele.ele_crs != null">
                                                        <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                                        {{ ele.ele_crs }}
                                                    </span>

                                                    <span v-if="showRoom && ele.ele_room != null">
                                                        <v-icon color="blue" small>mdi-warehouse</v-icon>
                                                        {{ ele.ele_room }}
                                                    </span>
                                                    <span v-if="ele.ele_event != null">
                                                        <v-icon color="green" small>mdi-cricket</v-icon>
                                                        {{ ele.ele_event }}
                                                    </span>
                                                    <span v-if="showFaculty && ele.ele_instructor != '--'">
                                                        <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                                                        {{ ele.ele_instructor }}
                                                    </span>
                                                    <span
                                                        v-if="showFaculty && ele.tt_ele_mul_inst != '' && user_type == 'Employee'">
                                                        <v-icon color="#9808EB" small>mdi-account-plus</v-icon>
                                                        <!-- {{ ele.tt_ele_mul_inst }} -->
                                                        <span v-for="i, index in ele.tt_ele_mul_inst" :key="index">
                                                            {{ index + 1 }}.{{ i }}</span>
                                                    </span>
                                                    <span class="pb-2"
                                                        v-if="ele.ele_link != null || ele.ele_crs != null">
                                                        <a :href="ele.ele_link" class="btn-view" v-if="ele.ele_link"
                                                            target="_blank">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn class="btn-view" x-small rounded depressed
                                                                        @click="markattendance(
                                                                            dis_ay,
                                                                            div_id,
                                                                            curr_lid,
                                                                            data.tt_id
                                                                        )
                                                                            ">
                                                                        <v-icon color="blue" class="btn-view"
                                                                            v-bind="attrs" v-on="on" size="20">mdi
                                                                            mdi-link</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span> Webinar Link!!! </span>
                                                            </v-tooltip>
                                                        </a>
                                                    </span>
                                                </v-btn>
                                            </template>
                                            <span>
                                                Elective Time Table
                                            </span>
                                        </v-tooltip>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <br>
                <v-card class="box" flat v-if="slot_type.length != 0 && div_tt_list != null">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Slots </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-row class="pt-2" align="center" justify="center">
                        <span class="pa-2" v-for="st in slot_type" :key="st.id">
                            <v-btn rounded class="p-1 m-1" :color="st.color">
                                {{ st.type }}
                            </v-btn>
                        </span>
                    </v-row>
                </v-card>
            </template>
        </v-card>
    </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
export default {
    props: {
        div_id: Number,
        curr_lid: Number,
        org: Number,
        tt_version: Number,
        sel_ay: Number
    },
    data() {
        return {
            div_tt_load: false,
            div_tt_list: null,
            slots: null,
            slot_type: null,
            dis_ay: null,
            div_name: null,
            std_name: null,
            user_type: null,
            loader: false,
            showRoom: true,
            showFaculty: true,
        };
    },
    watch: {
        div_id() {
            this.getData();
        },
        tt_version() {
            this.getData();
        },
        sel_ay() {
            this.getData();
        }
    },
    mounted() {
        this.getData();
        this.user_type = localStorage.getItem("EPS-ut");
    },
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table style='border-collapse:collapse;' border='1'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            exportTable.find('th, td').each(function () {
                $(this).css('border', '1px solid black');
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        markattendance(dis_ay, div_id, curr_lid, tt_id) {
            //alert(this.org) //added if condition because not using for management div t
            if (!this.org) {
                // alert("in if")
                var ay_id = dis_ay.id;
                const formData = {
                    div_id: div_id,
                    ay_id: ay_id,
                    lid: curr_lid,
                    time_table_id: tt_id,
                };
                axios
                    .post("/timeTable/markattendance", formData)
                    .then((res) => {
                        //console.log(res.data);
                        if (res.data.status == "YES") {
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.div_tt_load = false;
                    });
            }
        },
        getData() {
            this.div_tt_load = true;
            const formData = {
                div_id: this.div_id,
                curr_lid: this.curr_lid,
                org: this.org,
                tt_version: this.tt_version,
                sel_ay: this.sel_ay
            };
            axios
                .post("/timeTable/divTimeTable", formData)
                .then((res) => {
                    //console.log(res.data);
                    if (res.data.status == "YES") {
                        this.div_tt_list = res.data.tt_list;
                        this.slots = res.data.slot;
                        this.slot_type = res.data.slot_type;
                        this.faculty = res.data.faculty;
                        this.dis_ay = res.data.ay;
                        this.div_name = res.data.div_name;
                        this.std_name = res.data.std_name;
                    } else {
                        alert(res.data.status_reason);
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                    this.div_tt_load = false;
                });
        },
    },
};
</script>
<style scoped>
.checkbox-label {
    /* color: #fff !important; */
    margin-left: 10px;
    margin-top: 24px;
}

.btn-view {
    text-decoration: none !important;
}

td,
th {
    border: 1px solid black;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
    }

    td+td,
    th+th {
        width: auto;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
}

.btn-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: black;
    /* box-shadow: 0 0 20px rgb(190, 187, 187); */
    border-radius: 10px;
    display: block;
}

.btn-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: black;
    text-decoration: none;
}

.btn1-grad {
    background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
}

.btn1-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
    padding-top: none;
}

.btn1-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
    padding-top: none;
}
</style>
